import { useState } from "react";

export function SafeImage({
  src,
  fallback,
  alt,
  className,
}: {
  src: string;
  fallback: React.ReactNode;
  alt: string;
  className?: string;
}) {
  const [useFallback, setUseFallback] = useState(false);

  return useFallback ? (
    fallback
  ) : (
    <img
      alt={alt}
      className={className}
      src={src}
      onError={() => setUseFallback(true)}
    />
  );
}
